import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Category } from 'src/app/models/category';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  private dbPath = '/category';

  categoryRef: AngularFirestoreCollection<Category> = null;

  constructor(private fireService: AngularFirestore) {
    this.categoryRef = fireService.collection(this.dbPath);
  }

  createCategory(category: Category): void {
    this.categoryRef.add(category);
  }

  getAll() {
    return this.categoryRef.snapshotChanges();
  }

}
